/* eslint-disable import/no-cycle */
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import AquillaButton from 'aquilla/core/molecules/Button';
import { commasIndianFormat } from '@utils/textHelper';
import PriceBreakDownTable from '../BaseComponents/PriceBreakDownTable';
import { UPGRADESELECTIONSTEPS } from './UpgradePlanSelectionFlow';

const UpgradePreCheckoutFlowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6B};
`;

const ExtendSubscriptionWrapper = styled.div`
  display: flex;
  padding: ${Spacings.SPACING_3B};
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-i-blue-47);
  color: var(--color-i-blue);
  font-size: ${Fonts.H6};
  font-weight: ${Fonts.SEMIBOLD};
`;

const UpgradePreCheckoutFlowBottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const UpgradePreCheckoutFlowInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_3B};
`;

const BottomCtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const UpgradePreCheckoutPage = ({
  setFlowSteps,
  selectedPlan,
  goalDetails,
  setPreviousStep,
  onSubmit = (plan) => {}
}) => {
  const {
    checkout_dates,
    upgrade_refund: { refund_amount },
    price: iconicPrice,
    checkout_dates_with_benefits: {
      ends_at = '',
      starts_at = ''
    } = checkout_dates ?? {}
  } = selectedPlan ?? {};

  const priceBreakDown = [
    [
      {
        name: 'Original price',
        price: `₹${commasIndianFormat(iconicPrice)}`,
        type: 'positive'
      },
      {
        name: 'Plus refund',
        price: `-₹${commasIndianFormat(refund_amount)}`,
        type: 'negative'
      }
    ],
    [
      {
        name: 'Discounted price',
        price: `₹${commasIndianFormat(
          Math.floor(iconicPrice - refund_amount)
        )}`,
        type: 'positive'
      }
    ]
  ];

  return (
    <UpgradePreCheckoutFlowWrapper>
      <Typography variant="h2">
        Upgrade your {goalDetails?.name} to{' '}
        <span style={{ color: 'var(--color-i-orange)' }}>Iconic</span>
      </Typography>
      <UpgradePreCheckoutFlowBottomWrapper>
        <UpgradePreCheckoutFlowInfoWrapper>
          {selectedPlan && (
            <ExtendSubscriptionWrapper>
              Extend subscription from {starts_at} to {ends_at}.
            </ExtendSubscriptionWrapper>
          )}
          <PriceBreakDownTable priceBreakDown={priceBreakDown} />
        </UpgradePreCheckoutFlowInfoWrapper>
        <BottomCtaWrapper>
          <AquillaButton
            variant="primary"
            size="large"
            fullWidth
            onClick={() => onSubmit(selectedPlan)}
          >
            Continue to pay ₹
            {commasIndianFormat(Math.floor(iconicPrice - refund_amount))}
          </AquillaButton>
          <AquillaButton
            variant="secondary"
            size="large"
            fullWidth
            onClick={() => {
              setPreviousStep(UPGRADESELECTIONSTEPS.PRECHECKOUT);
              setFlowSteps(UPGRADESELECTIONSTEPS.PLANSELECTION);
            }}
          >
            Choose other duration
          </AquillaButton>
        </BottomCtaWrapper>
      </UpgradePreCheckoutFlowBottomWrapper>
    </UpgradePreCheckoutFlowWrapper>
  );
};

export default UpgradePreCheckoutPage;
